import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-dummy',
  templateUrl: './dummy.component.html',
  styleUrls: ['./dummy.component.css']
})
export class DummyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
